/// <reference path="../../typings/references.d.ts" />
module PartnershipsModule {

    angular
        .module('app')
        .constant('dataAccessUrl', '//pp-cuev-func-p.azurewebsites.net/api/v1');

}